import { render, staticRenderFns } from "./x-table.vue?vue&type=template&id=2bee9b04"
import script from "./x-table.vue?vue&type=script&lang=js"
export * from "./x-table.vue?vue&type=script&lang=js"
import style0 from "./x-table.vue?vue&type=style&index=0&id=2bee9b04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports